// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ef461";
export var footerBottom = "footer-module--footer-bottom--ba595";
export var footerContact = "footer-module--footer-contact--3ece7";
export var footerContent = "footer-module--footer-content--3c22e";
export var footerInfo = "footer-module--footer-info--ea583";
export var footerLinks = "footer-module--footer-links--2cfcd";
export var footerNewsletter = "footer-module--footer-newsletter--359c5";
export var footerSocial = "footer-module--footer-social--e42e1";
export var goToHead = "footer-module--go-to-head--06ed3";